import ShoppingMVController from "emun.shopping/shopping-container.controller.es6";
export const IS_CMS = (ENV_TAGS || []).indexOf("Cms") >= 0;

export default class OneCoastShoppingMVController extends ShoppingMVController {
  constructor($cart) {
    super($cart);
    const $ctrl = this;
    //this.enableTopFilters = false;
  }
}
